import styled from "@emotion/styled";
import { Divider, Theme, Typography } from "@yuno/design-system-web";
import { useContext } from "react";
import logo from "../../../../assets/styling/logo.svg";
import logoAlt from "../../../../assets/styling/logo-alt.svg";
import { ThemeContext } from "../../../../context/theme-context";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-orientation: column;
  margin-bottom: 60px;
`;

const Image = styled.img<{ theme?: Theme }>`
  padding-right: 10px;
  object-fit: fit;
`;

const Title = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography.base.regular};
  color: ${({ theme }) => theme.palette.grey[5]};
  padding-left: 10px;
  border-left: 1px solid ${({ theme }) => theme.palette.grey[2]};
`;

export const Logo = () => {
  const { themeSelected } = useContext(ThemeContext);

  return (
    <Container>
      <Image
        src={themeSelected === "darkMode" ? logoAlt : logo}
        width="116"
        height={"16px"}
      />
      <Title>Order review</Title>
    </Container>
  );
};
